import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../_services/alert.service";
import { environment } from "../../../../environments/environment";
import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';

const { API_URL } = environment;
@Component({
  selector: 'app-passport-check',
  templateUrl: './passport-check.component.html',
  styleUrls: ['./passport-check.component.scss']
})
export class PassportCheckComponent implements OnInit {
  orvreport: FormGroup;
  form: FormGroup;
  Resultdata: any;
  merchantId:any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 0;
  collectionSize: number = 0;
  merchantdis: boolean = true;
  filedis: boolean = true;
  flagcheck:boolean=true;
  selectedFile:any;
  loading: boolean = false;
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];
  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;
   public rowData: any[];
  //public rowData: ColDef[] = [];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  passportCheck:FormGroup;
  isForm2Submitted:boolean=false;
 
  public columnDefs: ColDef[] = [   
    { field: 'name', tooltipField: 'name', headerName: 'Name on Passport'},
    { field: 'passportNumber', tooltipField: 'passportNumber', headerName: 'Passport Number'},
    { field: "dob", tooltipField: 'dob', headerName: 'D.O.B' },
    { field: 'surname',tooltipField: 'surname', headerName: 'surname' },  
    { field: 'status', tooltipField: 'status', headerName: 'Status'},
    { field: 'passportStatus', tooltipField: 'passportStatus', headerName: 'passportStatus'},   
  ];

  tableSelectedColumn: ColDef[] = [...this.columnDefs];
  private responsePassport:any;
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService, ) {
 

    this.passportCheck = formBuilder.group({
      name: [""],
      passportNumber: ["",Validators.required],
      dob: ["",Validators.required],        
      origin: [""],   
      },    
    );
  }
    ngOnInit(): void {
     this.fetchPassportList();
    }

    onSubmit(formvalue: any, type: any) {
      this.isForm2Submitted=true;
      if(!this.passportCheck.valid){  

      }
      else{
      setTimeout(() => {      
           let passportData = {             
              "name":  formvalue.name,
              "passportNumber":formvalue.passportNumber,
              "dob":formvalue.dob, 
              "origin":formvalue.origin
            };        
            this.loading = true
            document?.getElementById('submitloading')?.classList.add("spinner-border")
            document?.getElementById('submitloading')?.classList.add("spinner-border-sm")
            // this.apiHttpService.post(`${API_URL}/passport/${passportData.origin}/${passportData.name}/${passportData.passportNumber}/${passportData.dob}?pageSize=` + this.pageSize + '&page=' + (this.currentPage - 1), null).subscribe((data: any) => {
              this.apiHttpService.post(`${API_URL}/passport/${passportData.origin}/${passportData.name}/${passportData.passportNumber}/${passportData.dob}`, null).subscribe((data: any) => {
           
             console.log("JSON.stringify(data)======"+JSON.stringify(data))
               // this.collectionSize = data;
               // this.rowData=data;
                this.fetchPassportList(); 
                this.loading = false;             
                document?.getElementById('submitloading')?.classList.remove("spinner-border");
                document?.getElementById('submitloading')?.classList.remove("spinner-border-sm");            
              }
              );      
        
      },0);
    }
    }

    fetchPassportList(){
      debugger
      // this.apiHttpService.get(`${API_URL}/passport/verify/list?pageSize=` + this.pageSize + '&page=' + (this.currentPage - 1), null).subscribe((data: any) => {  
        this.apiHttpService.get(`${API_URL}/passport/verify/list`).subscribe((data: any) => {      
        this.collectionSize = data;
        this.rowData=data;   
        // alert("rowData====="+JSON.stringify(this.rowData))
        console.log("JSON.stringify(this.rowData)===="+JSON.stringify(this.rowData))
         })

    }
   
    file:any;  
    onFilterOpened(param: FilterOpenedEvent | any) {
      console.log("onFilterOpened----->", param);
    }
    onFilterModified(param: FilterModifiedEvent | any) {
      debugger
      const temp = param?.filterInstance;
      this.filterObj[param?.column?.colId] = temp;
    }
    onRowDoubleClicked(param: RowClickedEvent | any) {
      debugger
      let coldata=param.data;
     let merchant=coldata.merchantId;
      this.apiHttpService
      .post(
        `${API_URL}/docs/download/${coldata.merchantId}/OSV`, null
        )
      .subscribe((data) => (
       this.downloadPdf(data,merchant)
      ));
      param.node.setExpanded(!param.node.expanded);
    }
    downloadPdf(data:any,merchantdata:any) {
      const linkSource =
      'data:application/octet-stream;base64,' +data.text;
      const downloadLink = document.createElement('a');
      const fileName = merchantdata+'_OSV.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    async onRowClicked(param: RowClickedEvent | any) {
      this.SingleRow = param.data
    }
    onPageSizeChanges($event: Event) {
      this.apiHttpService
        .post(
          `${API_URL}/docs/fetchDocs/${this.pageSize}/${this.currentPage}?type=OSV`, null
          )
        .subscribe((data) => (
          this.rowData = data.content?.data || Array.isArray(data.content) ? data.content: [],
          this.collectionSize = data.totalElements,
          this.gridApi.applyTransaction({ add: this.rowData })
        ));
    }
    onPaginationChange(param: PaginationChangedEvent | any) {
      debugger
      this.gridApi.paginationGoToPage(param - 1)
  
     }

  }